import { Divider, List, SxProps } from '@mui/material';
import * as Preact from 'preact';
import * as BasketProduct from './M_BasketProduct';

export type BasketItem = {
    id: string;
    pieceThumbnail: string;
    pieceName: string;
    piecePrice: number;
    pieceOriginalPrice: number;
    pieceCount: number;
};

export interface Props {
    basketItems: BasketItem[];
    sx?: SxProps;
}

export const Component = (p: Props) => {
    return (
        <>
            {p.basketItems && (
                <List sx={{ paddingTop: '0px', paddingBottom: '0px', ...p.sx }}>
                    {p.basketItems.map((product, i, { length }) => (
                        <>
                            <BasketProduct.Component
                                productThumbnail={product.pieceThumbnail}
                                productName={product.pieceName}
                                productPrice={product.piecePrice * product.pieceCount}
                                productOriginalPrice={
                                    product.pieceOriginalPrice * product.pieceCount
                                }
                                productCount={product.pieceCount}
                            />
                            {i + 1 !== length && (
                                <Divider flexItem component="li" sx={{ margin: '0 24px' }} />
                            )}
                        </>
                    ))}
                </List>
            )}
        </>
    );
};

Component.displayName = 'BasketList';
